import {
  differenceInHours,
  differenceInMinutes,
  differenceInSeconds,
} from 'date-fns';
import { useEffect, useState } from 'react';
import { useInterval } from 'react-use';

const zeroPad = (num = 0) => String(num).padStart(2, '0');

const calculateTimeDifference = ({ slaDeadline }: { slaDeadline: number }) => {
  const now = Date.now();
  const isOverdue = slaDeadline <= now;
  const hours = Math.abs(differenceInHours(slaDeadline, now));
  const minutes = Math.abs(differenceInMinutes(slaDeadline, now)) % 60;
  const seconds = Math.abs(differenceInSeconds(slaDeadline, now)) % 60;
  const sign = isOverdue ? '-' : '';
  return `${sign}${zeroPad(hours)}:${zeroPad(minutes)}:${zeroPad(seconds)}`;
};

interface Props {
  slaDeadline: number;
}
const useSlaTimer = ({ slaDeadline }: Props) => {
  const [countdown, setCountdown] = useState('');

  const updateColorAndCountdown = () => {
    const timeDifference = calculateTimeDifference({
      slaDeadline,
    });
    setCountdown(timeDifference);
  };

  useEffect(updateColorAndCountdown, [slaDeadline]);
  useInterval(updateColorAndCountdown, 1000);

  return {
    countdown,
  };
};

export default useSlaTimer;
